import { Injectable } from '@angular/core';
import { MbbRouter } from '../modules/mbb/models/mbb-offerings-response.model';

@Injectable({
  providedIn: 'root',
})
export class MbbProductHelperService {
  private static isRouterAvailableWithLogistics(router: MbbRouter): boolean {
    if (router.productAvailability === 'permanentlyOutOfStock') return false;
    if (!router.isBackorderEnabled && router.stock === 0) return false;

    return true;
  }

  static getAvailableLogisticsRouters(routers: MbbRouter[]): MbbRouter[] {
    return routers.filter(router => this.isRouterAvailableWithLogistics(router));
  }
}
